(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["floatsuit-compact-picker"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('floatsuit-compact-picker')){
 customElements.define('floatsuit-compact-picker',class extends HTMLElement{
  connectedCallback(){
   this.controller=new AbortController();
   this.root=this.closest('.product__info-container');
   if(!this.root)return;
   this.compactLabels=()=>{
    this.root.querySelectorAll('select option').forEach(option=>{
     if(option.value.includes(' · Height ')){
      const [age,height]=option.value.split(' · Height ');
      option.textContent='Height '+height.split(' / ')[0]+' · '+age;
     }
    });
    this.root.querySelectorAll('quantity-breaks .quantity-break__selector-item').forEach(row=>{
     row.querySelectorAll('select').forEach((select,index)=>select.setAttribute('aria-label',(index===0?'Color':'Size')+' for suit '+(Number(row.dataset.selectIndex)+1)));
    });
   };
   this.savedRows=new Map();
   this.sync=()=>{
    const picker=this.root.querySelector('.vfs-picker');
    const bundles=this.root.querySelector('quantity-breaks');
    if(!picker||!bundles)return;
    const chosen=bundles.querySelector('input[name="quantity"]:checked');
    const card=chosen&&bundles.querySelector('label[for="'+chosen.id+'"]');
    if(card){
     const variants=JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
     const ids=[];
     card.querySelectorAll('.quantity-break__selector-item').forEach((row,index)=>{
      const selects=[...row.querySelectorAll('select')];
      const key=card.dataset.input+':'+index;
      const selection=this.savedRows.get(key)||selects.map(select=>select.value);
      this.savedRows.set(key,selection);
      selects.forEach((select,i)=>{select.value=selection[i]});
      const variant=variants.find(item=>item.options.every((value,i)=>value===selection[i]));
      if(variant){row.dataset.selectedId=variant.id;ids.push(variant.id)}
     });
     if(ids.length){bundles.selectedVariants[card.dataset.input]=ids;bundles.handleChange({target:chosen})}
    }
    this.compactLabels();
   };
   this.root.addEventListener('change',event=>{
    const row=event.target.closest('quantity-breaks .quantity-break__selector-item');
    if(row){
     const card=row.closest('.quantity-break');
     this.savedRows.set(card.dataset.input+':'+row.dataset.selectIndex,[...row.querySelectorAll('select')].map(select=>select.value));
    }
    queueMicrotask(this.compactLabels);
    if(event.target.closest('.vfs-picker')||event.target.matches('quantity-breaks input[name="quantity"]'))queueMicrotask(this.sync);
   },{signal:this.controller.signal});
   this.root.addEventListener('submit',this.sync,{capture:true,signal:this.controller.signal});
   this.observer=new MutationObserver(records=>{
    if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches('.quantity-break__variants,.quantity-break__selector-item')||node.querySelector('.quantity-break__selector-item')))))this.sync();
   });
   this.observer.observe(this.root,{childList:true,subtree:true});
   customElements.whenDefined('quantity-breaks').then(()=>{if(this.isConnected)this.sync()});
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
 });
}
  } catch(e) { console.error(e); }
})();

})();
